export const IMPERSONATION_TOKEN_KEY = "@/Impersonation/token";
